'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import { useRouter } from 'next/navigation';
import { MOCK_INTIMACAO_SENTENCA } from '../../mocks/encerramento.mock';
import type { DocumentoEncerramentoContainerProps, IntimacaoSentencaDados } from '../../types/encerramento.types';
import { rotaProcessoPorOrigem } from '../../utils/rotaProcessoPorOrigem';
import { DocumentoCarregando, DocumentoComErro, DocumentoNaoEncontrado, DocumentoSemPermissao } from './EstadosDocumento';
import { IntimacaoSentencaDocumento } from './IntimacaoSentencaDocumento';
export function IntimacaoSentencaContainer(t0) {
  const $ = _c(13);
  const {
    processoId,
    origem
  } = t0;
  const router = useRouter();
  const [dados] = useState(MOCK_INTIMACAO_SENTENCA);
  const [carregando] = useState(false);
  const [erro] = useState(null);
  const [semPermissao] = useState(false);
  let t1;
  if ($[0] !== origem || $[1] !== processoId || $[2] !== router) {
    t1 = () => {
      router.push(rotaProcessoPorOrigem(origem, processoId));
    };
    $[0] = origem;
    $[1] = processoId;
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleVoltar = t1;
  if (carregando) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <DocumentoCarregando />;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (semPermissao) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <DocumentoSemPermissao />;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (erro) {
    let t2;
    if ($[6] !== erro) {
      t2 = <DocumentoComErro mensagem={erro} />;
      $[6] = erro;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  if (!dados) {
    let t2;
    if ($[8] !== handleVoltar) {
      t2 = <DocumentoNaoEncontrado onVoltar={handleVoltar} />;
      $[8] = handleVoltar;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  let t2;
  if ($[10] !== dados || $[11] !== handleVoltar) {
    t2 = <IntimacaoSentencaDocumento dados={dados} onVoltar={handleVoltar} />;
    $[10] = dados;
    $[11] = handleVoltar;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}